module.exports = __webpack_public_path__ + "img/p1-pic.f59d9b11.jpg";